import { Button } from '@factorialco/deprecated-design-system'
import {
  FinanceContactDocumentsDataCollectionDocument,
  SoftDeleteContactDocumentsDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export interface DeleteDocumentsModalProps {
  onClose: () => void
  documentIds: number[]
  contactId: number
}

const DeleteDocumentsModal = ({ onClose, documentIds, contactId }: DeleteDocumentsModalProps) => {
  const [softDeleteContactDocument] = useMutation(SoftDeleteContactDocumentsDocument, {
    extractorFn: (mutation) => mutation.financeMutations.softDeleteFinanceContactDocument,
    refetchQueries: [FinanceContactDocumentsDataCollectionDocument],
    awaitRefetchQueries: true,
  })

  const onSubmit = async () => {
    const result = await softDeleteContactDocument({
      variables: { ids: documentIds, contactId },
    })
    const handled = handleResult(result, () => undefined)
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      track(trackingEvents.accounting.contactDocuments.clickOnConfirmDeleteFile)
      onClose()
    }
  }

  const title =
    documentIds.length > 1
      ? i18n.t('finance.contacts.files.delete_modal.title_multiple')
      : i18n.t('finance.contacts.files.delete_modal.title_one')

  const description =
    documentIds.length > 1
      ? i18n.t('finance.contacts.files.delete_modal.description_multiple', {
          files_number: documentIds.length,
        })
      : i18n.t('finance.contacts.files.delete_modal.description_one')

  return (
    <Modal
      illustration={'delete'}
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button
            type="secondary"
            onClick={() => {
              track(trackingEvents.accounting.contactDocuments.clickOnCancelDeleteFile)
              onClose()
            }}
          >
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onSubmit}>{i18n.t('common.delete')}</Button>
        </>
      }
    />
  )
}

export default DeleteDocumentsModal
